
const SET_REMOTE_GROUP_ID = 'SET_REMOTE_GROUP_ID';
const SET_USER_PROFILE = 'SET_USER_PROFILE';

const initialState = {
    remoteGroup: null,
    chatUserProfile: null,
};

export function setRemoteGroup(payload) {
    return {
        type: SET_REMOTE_GROUP_ID,
        payload,
    }
}
export function setChatUserProfile(payload){
    return {
        type: SET_USER_PROFILE,
        payload
    }
}

const ACTION_HANDLERS = {

    [SET_REMOTE_GROUP_ID]: (state, action) => {
        return { ...state, remoteGroup: action.payload }
    },
    [SET_USER_PROFILE]: (state, action) => {
        return { ...state, chatUserProfile: action.payload }
    },
};

export default function ChatReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state
}
